module.exports = __webpack_public_path__ + "img/right_bgc.bcf20ea5.png";